import { Skeleton } from "@mui/material";
import styles from "../styles/customerStyles.module.css";

export const chipColorDecisionMaker = (type, total, isLoading, style) => {
  if (type === "All" || type === "Variants" || type === "Pickable" || type === "non-electric-regular") {
    return (
      <div
        style={{
          ...style,
          background: "rgba(174, 205, 255, 0.5)",
          color: "#1890FF",
        }}
        className={styles.order_tabs}
      >
        {isLoading ? <Skeleton variant="rectangular" />: total || 0}
      </div>
    );
  }
  if (type === "Completed" || type === "In Transit" || type === "Ship" || type === "electric-regular" || type === "archived" || type ==="withdraw") {
    return (
      <div
        style={{
          ...style,
          background: "rgba(145, 85, 253, 0.25)",
          color: "#9025FA",
        }}
        className={styles.order_tabs}
      >
        {isLoading ? <Skeleton variant="rectangular" />: total || 0}
      </div>
    );
  }
  if(type === "liquid-regular" || type ==="Attention" || type === "Waiting" || type === "refund" || type === "requote" || type === 'Reply'){
    return (
      <div
        style={{
          ...style,
          background: "#ecf88e",
          color: "#ffcd03",
        }}
        className={styles.order_tabs}
      >
        {isLoading ? <Skeleton variant="rectangular" />: total || 0}
      </div>
    );
  }
  if (type === "Processing") {
    return (
      <div
        style={{
          ...style,
          background: "rgba(102, 155, 244, 0.29)",
          color: "#669BF4",
        }}
        className={styles.order_tabs}
      >
         {isLoading ? <Skeleton variant="rectangular" />: total || 0}
      </div>
    );
  }
  if (type === "Shipped" || type === "Images" || type === "Delivered" || type === "accepted" || type === "non-electric-premium") {
    return (
      <div
        style={{
          ...style,
          background: "rgba(112, 210, 40, 0.31)",
          color: "#6FD226",
        }}
        className={styles.order_tabs}
      >
        {isLoading ? <Skeleton variant="rectangular" />: total || 0}
      </div>
    );
  }
  if (type === "pending") {
    return (
      <div
        style={{
          ...style,
          background: "rgba(102, 155, 244, 0.29)",
          color: "rgb(102, 155, 244)",
        }}
        className={styles.order_tabs}
      >
        {isLoading ? <Skeleton variant="rectangular" />: total || 0}
      </div>
    );
  } 

  if (type === "Process" || type === "deposit") {
    return (
      <div
        style={{
          ...style,
          background: "#EAE8ED",
          color: "#a2a2a2",
        }}
        className={styles.order_tabs}
      >
        {isLoading ? <Skeleton variant="rectangular" />: total || 0}
      </div>
    );
  } 
  // if (type === "Attention") {
  //   return (
  //     <div
  //       style={{
  //         background: "#f1d3c3",
  //         color: "#f8aa27",
  //       }}
  //       className={styles.order_tabs}
  //     >
  //       {total || 0}
  //     </div>
  //   );
  // } 

 else {
    return (
      <div
        style={{
          ...style,
          background: "#FFCFCF",
          color: "#FF7E7E",
        }}
        className={styles.order_tabs}
      >
        {isLoading ? <Skeleton variant="rectangular" />: total || 0}
      </div>
    );
  }

  }